import { type BaseText, type Descendant } from 'slate';

const getTextFromRichText = (text: { children: Descendant[] }[]): string =>
  (text[0]?.children?.[0] as BaseText)?.text || '';

export default getTextFromRichText;
